import React from "react";

const socialMedia = {
  color: "#919191",
  fontSize: 50,
  marginRight: 30,
};

const changeColor = (e) => {
  e.target.style.color = "#fcbe04";
};

const restoreColor = (e) => {
  e.target.style.color = "#919191";
};

class RenovationVideos extends React.Component {
  render() {
    return (
      <div>
        {/* row 1 */}
        <div class="row" style={{ marginLeft: 20, marginRight: 20 }}>
         <iframe
              title="title18"
              className="col-lg-4"
              width="560"
              height="315"
              style={{marginBottom: 30}}
              src="https://www.youtube.com/embed/UeZvQLoNhUU"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
         ></iframe>
         <iframe
              title="title17"
              className="col-lg-4"
              width="560"
              height="315"
              style={{marginBottom: 30}}
              src="https://www.youtube.com/embed/-pmtGQVdyv0"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
         ></iframe>
        <iframe
              title="title16"
              className="col-lg-4"
              width="560"
              height="315"
              style={{marginBottom: 30}}
              src="https://www.youtube.com/embed/RbsG5FhsNoY"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
          ></iframe>
          <iframe
              title="title15"
              className="col-lg-4"
              width="560"
              height="315"
              style={{marginBottom: 30}}
              src="https://www.youtube.com/embed/QHYWwI-zy0k"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
          ></iframe>
          <iframe
              title="title14"
              className="col-lg-4"
              width="560"
              height="315"
              style={{marginBottom: 30}}
              src="https://www.youtube.com/embed/sDaPSEkZsvQ"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
          ></iframe>
          <iframe
            title="title1"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/9fnvNlO8j2c"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <iframe
            title="title2"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/Opn7REPd0YQ"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <iframe
            title="title3"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/zYMJTMX2q9Y"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        {/*</div>*/}
        {/* row2 */}
        {/*<div class="row" style={{ marginLeft: 20, marginRight: 20 }}>*/}
          <iframe
            title="title4"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/BKaRbX-mJjY"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <iframe
            title="title5"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/-aB0TpnXric"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <iframe
            title="title5"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/e6sRSuQSkUM"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        {/*</div>*/}
        {/* row3 */}
        {/*<div class="row" style={{ marginLeft: 20, marginRight: 20 }}>*/}
          <iframe
            title="title6"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/R4kN32zJfHE"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <iframe
            title="title7"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/eQ3YRxCBLzo"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
           <iframe
            title="title8"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/M-PaJtrZ4GE"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        {/*</div>*/}
         {/* row4 */}
         {/*<div class="row" style={{ marginLeft: 20, marginRight: 20 }}>*/}
          <iframe
            title="title9"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/cvDgKd8_P9I"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <iframe
            title="title10"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/Zr1CgFrS97Y"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
           <iframe
            title="title11"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/SPh3-6H7a7M"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        {/*</div>*/}
        {/* row4 */}
        {/*<div class="row" style={{ marginLeft: 20, marginRight: 20 }}>*/}
           <iframe
            title="title12"
            class="col-lg-4"
            width="560"
            height="315"
            style={{ marginBottom: 30 }}
            src="https://www.youtube.com/embed/YbY6_91krD0"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
         ></iframe>
            <iframe
                title="title13"
                className="col-lg-4"
                width="560"
                height="315"
                style={{marginBottom: 30}}
                src="https://www.youtube.com/embed/4mhbdMXWgp0"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            ></iframe>
        </div>
        <div class="container" style={{ marginBottom: 30 }}>
          <div class="row">
            <div class="col-lg-12">
              <center>
                <p>Ακολουθήστε μας στα social media για περισσότερα:</p>
                <p>
                  <a
                    href="https://www.facebook.com/qrstand/?modal=admin_todo_tour"
                    rel="noopener noreferrer"
                    target="_blank"
                    onMouseOver={changeColor}
                    onMouseOut={restoreColor}
                  >
                    <i
                      class="fa fa-facebook-square"
                      aria-hidden="true"
                      style={socialMedia}
                    ></i>
                  </a>
                  <a
                    href="https://www.instagram.com/qrstand/"
                    rel="noopener noreferrer"
                    target="_blank"
                    onMouseOver={changeColor}
                    onMouseOut={restoreColor}
                  >
                    <i
                      class="fa fa-instagram"
                      aria-hidden="true"
                      style={socialMedia}
                    ></i>
                  </a>
                  <a
                    href="https://www.youtube.com/user/VoulaDeco"
                    rel="noopener noreferrer"
                    target="_blank"
                    onMouseOver={changeColor}
                    onMouseOut={restoreColor}
                  >
                    <i
                      class="fa fa-youtube"
                      aria-hidden="true"
                      style={socialMedia}
                    ></i>
                  </a>
                </p>
              </center>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RenovationVideos;



// WEBPACK FOOTER //
// ./src/components/renovation-videos.js